<template>
    <div class="leadership">
        <div class="container">
            <div class="content">
                <div v-html="headingtext"></div>
                <div class="row no-margin">
                    <div class="person" v-for="person in persons">
                        <div class="image">
                            <img :src="person.image.url" alt />
                        </div>
                        <div class="text">
                            <div class="name">{{person.name}}</div>
                            <div class="status">{{person.status}}</div>
                            <ul class="socials-light">
                                <li v-if="person.social_media.link_to_facebook">
                                    <a :href="person.social_media.link_to_facebook">
                                        <div class="fb-icon"></div>
                                    </a>
                                </li>
                                <li v-if="person.social_media.link_to_twitter">
                                    <a :href="person.social_media.link_to_twitter">
                                        <div class="tw-icon"></div>
                                    </a>
                                </li>
                                <li v-if="person.social_media.link_to_linkedin">
                                    <a :href="person.social_media.link_to_linkedin">
                                        <div class="in-icon"></div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="button" class="button">
                    <a :href="button_link" class="btn default white" v-html="button_title"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "block-leadership",
    data() {
        return {
            headingtext: this.blockdata.heading_text,
            persons: this.blockdata.persons,
            button: this.blockdata.button,
            button_title: this.blockdata.button.title,
            button_link: this.blockdata.button.url
        };
    },
    mounted: function() {
        // console.log("blockata", this.blockdata);
    }
};
</script>


// WEBPACK FOOTER //
// BlockLeadership.vue?602f4a45